import React, { useEffect, useRef, useState } from "react"; 
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import ConfirmModal from "../../../../../../components/ConfirmModal";
import svg29 from "../../../../../../assets/svg/svg29.svg";
import svg44 from "../../../../../../assets/svg/svg44.svg";
import svg45 from "../../../../../../assets/svg/svg45.svg";
import svg46 from "../../../../../../assets/svg/svg46.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, List } from "antd";
import toast from "react-hot-toast";
import {
  fetchData,
  fetchFiles,
} from "../../../../../../features/fetch/fetchSlice";
import { formatText } from "../../../../../../utils";
import { save } from "../../../../../../features/save/saveSlice";
import DocumentAdd from "./DocumentAdd";

// const documentData = [
//   {
//     id: 1,
//     title: "COMPANY_DOCUMENTS",
//     files: [
//       { id: 1, name: "Contract.pdf" },
//       { id: 2, name: "Contract.pdf" },
//     ],
//   },
//   {
//     id: 2,
//     title: "PROJECT_DOCUMENTS",
//     files: [
//       { id: 3, name: "Contract.pdf" },
//       { id: 4, name: "Contract.pdf" },
//     ],
//   },
// ];
const documentData = [
  {
    id: 1,
    title: "PROJECT_IMAGES",
  },
   
];

function ProjectImages() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "api/v2/projectFiles/get";
  const { loading, data, count, activeObjOngoingProject } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
    })
  );

  const [prodd, setProdd] = useState();
  const [prodd2, setProdd2] = useState();
  const { open, handleCancel, handleOpen } = useModalToggle();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/projectFiles/delete",
        pfId: prodd?.id,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleAdd = async (item) => {
    await setProdd();
    await setProdd2(item);
    await handleOpen();
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        pfProjectId: activeObjOngoingProject?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }
  const transformedFiles = data?.reduce((acc, curr) => {
    const category = curr?.pfFileCategory;

    if (!acc[category]) {
      acc[category] = [];
    }

    acc[category].push({
      id: curr?.pfId,
      name: curr?.pfFileName || curr?.pfFilePath,
      original: curr,
    });

    return acc;
  }, {});

  const finalData = documentData?.map((group) => ({
    ...group,
    files: transformedFiles[group?.title] || [],
  }));

  const downloadFile = async (item) => {
    try {
      const res = await dispatch(
        fetchFiles({ file: item?.original?.pfFilePath })
      );
      if (res?.payload) {
        window.open(res.payload, "_blank");
      }
    } catch (error) {
      console.error("Failed to open file:", error);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  return (
    <div>
      <div className="flex flex-col w-full  flex-1">
        <div className="form-add-h">Project Images</div>
      </div>
      {finalData?.map((group) => (
        <div key={group?.id} className="mt-[1.75rem]  ">
          <div className="flex items-center justify-between py-[0.8125rem] px-[1.25rem]  bg-[#F1F3F5] rounded-[.5rem]">
            <div className="flex items-center gap-x-[1.25rem]">
              <span className="bg-[#D6E1F5] w-[2.25rem] h-[2.25rem] flex items-center justify-center rounded-full text-[#0092CC] font-[600] text-[1rem] font-interSans">
                {group?.id}
              </span>
              <span className="text-[#23262F] text-[1rem] font-[600] font-interSans">
                {formatText(group?.title)}
              </span>
            </div>
            {activeObjOngoingProject?.projectStatus === "STALLED" ? null : (
              <button
                onClick={() => handleAdd(group)}
                type="button"
                className="bg-[#0092CC] flex items-center justify-center p-[.5rem] rounded-[.375rem]"
              >
                <img src={svg29} alt="svg29" />
              </button>
            )}
          </div>

          <List
            dataSource={group?.files}
            renderItem={(file) => (
              <List.Item className="!mt-[1rem] !mb-[1rem] !pl-[4.75rem] !pr-[1.25rem] flex justify-between items-center ">
                <div className="flex items-center gap-2">
                  <img src={svg44} alt="svg44" />
                  <span className="text-[#424242] font-interSans text-[.875rem] font-[400]">
                    {file.name}
                  </span>
                </div>
                <div
                  className="flex gap-x-[1.88rem]"
                  onClick={() => setProdd(file)}
                >
                  <img
                    src={svg45}
                    alt="svg45"
                    className="cursor-pointer"
                    onClick={() => downloadFile(file)}
                  />
                  {activeObjOngoingProject?.projectStatus ===
                  "STALLED" ? null : (
                    <img
                      className="cursor-pointer"
                      src={svg46}
                      alt="svg46"
                      onClick={() => handleOpenDelete()}
                    />
                  )}
                </div>
              </List.Item>
            )}
          />
        </div>
      ))}

      <DocumentAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
        prodd2={prodd2}
      />
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default ProjectImages;
